import { getHeaders, fetcher } from './ApiClient';

export interface ApiPlaygroundOptionsResponseDef {
    apiPlaygroundOptions: {
        useLegacyApiPlayground: boolean;
    };
}

const getApiPlaygroundOptions = (apiEntityId: string): Promise<ApiPlaygroundOptionsResponseDef> => {
    const uri = `api-entities/${apiEntityId}/draft-portal-settings/api-playground-options`;

    return fetcher<ApiPlaygroundOptionsResponseDef>(uri, 'GET', getHeaders());
};

const updateApiPlaygroundOptions = (apiEntityId: string, body: ApiPlaygroundOptionsResponseDef) => {
    const uri = `api-entities/${apiEntityId}/draft-portal-settings/api-playground-options`;

    return fetcher<ApiPlaygroundOptionsResponseDef>(uri, 'PUT', getHeaders(), body);
};

export { updateApiPlaygroundOptions, getApiPlaygroundOptions };
